import { render, staticRenderFns } from "./DiseaseName.vue?vue&type=template&id=4693f358&scoped=true"
import script from "./DiseaseName.vue?vue&type=script&lang=js"
export * from "./DiseaseName.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4693f358",
  null
  
)

export default component.exports